"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./product-dashboard-location.response"), exports);
__exportStar(require("./product-dashboard-metadata.response"), exports);
__exportStar(require("./product-dashboard-open-orders.response"), exports);
__exportStar(require("./product-dashboard-order-line-product.response"), exports);
__exportStar(require("./product-dashboard-order-line.response"), exports);
__exportStar(require("./product-dashboard-product-manufacturer.response"), exports);
__exportStar(require("./product-dashboard-product-um.response"), exports);
__exportStar(require("./product-dashboard-sales-order-customer.response"), exports);
__exportStar(require("./product-dashboard-sales-order-release.response"), exports);
__exportStar(require("./product-dashboard-sales-order.response"), exports);
__exportStar(require("./production-dashboard-data.response"), exports);
__exportStar(require("./production-dashboard-search.response"), exports);
__exportStar(require("./releases-dashboard-data.response"), exports);
__exportStar(require("./releases-dashboard-search.response"), exports);
__exportStar(require("./shipping-dashboard-data.response"), exports);
__exportStar(require("./shipping-dashboard-search.response"), exports);
//# sourceMappingURL=index.js.map